import styled from "styled-components";

export const H2Component = styled.h2`
    font-weight: 700;
    font-size: 16px;
    color: var(--text-color);
    margin: 0 !important;
    padding: 0 !important;
`